<template>
  <div class="home-bg" >

    <!-- 导航栏 -->
    <div class="home-nav-box">
      <!-- <div class="home-subtitle"><span>{{$t('T_TOP_TITLE_EPSON')}}</span> <br/>{{$t('T_TOP_TITLE')}}</div> -->
      <Header link=""></Header>
      <div class="home-panel">
        <ul>
          <li v-if="isSearch">
            <div class="home-title">{{$t('T_SEARCH_MODEL')}}</div>
            <div class="home-des">{{$t('T_TOPVIEW_SEARCH_PROJECTOR')}}</div>
            <van-button   round plain @click="changeRouter('searchProjectors')">{{$t('T_SEARCH')}}</van-button>
          </li>
          <li v-if="isCategolies">
            <div class="home-title">{{$t('T_SEARCH_CATEGORY')}}</div>
            <div class="home-des">{{$t('T_TOPVIEW_CATEGORIES')}}</div>
            <van-button   round plain @click="changeRouter('categolies')">{{$t('T_SEARCH')}}</van-button>
          </li>
          <!-- 勿删 待用 -->
          <li v-if="isSpecification">
            <div class="home-title">{{$t('T_SEARCH_SPEC')}}</div>
            <div class="home-des">{{$t('T_TOPVIEW_SPECIFICATION')}}</div>
            <van-button round plain @click="changeRouter('specification')">{{$t('T_SEARCH')}}</van-button>
          </li>
          <li v-if="isInstallCondition">
            <div class="home-title">{{$t('T_SEARCH_CONDITION')}}</div>
            <div class="home-des">{{$t('T_TOPVIEW_CONDITION')}}</div>
            <van-button round plain @click="changeRouter('tbd')">{{$t('T_SEARCH')}}</van-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Header from '@/components/header'
export default {
  name: 'home',
  data () {
    return {
      showSelectPanel: false,
      modelWidth: 300,
      isSearch: true,
      isCategolies: true,
      isSpecification: true,
      isInstallCondition: true
    }
  },
  components: {
    Header
  },
  computed: {
    ...mapState(['languageChecked'])
  },
  methods: {
    changeRouter (router) {
      this.SET_SEARCHPARAMS({})
      this.$router.push({ path: '/' + router })
    },
    ...mapMutations([ 'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'LANGUAGE', 'SET_SEARCHPARAMS' ])
  },
  created () {
    // if (this.languageChecked === false) {
    //   let lang = navigator.language || navigator.userLanguage
    //   lang = lang.substr(0, 2)
    //   if (lang === 'zh' || lang === 'ja' || lang === 'en') {
    //     this.LANGUAGE(lang)
    //     this.$i18n.locale = lang
    //   }
    // }
    this.SEARCHMATCHINGMODELDATA(this.ProjectorSpec)
    this.SEARCHSELECTEDMODELDATA(this.ProjectorSpec[0])
    this.MATCHINGMODELDATA(this.ProjectorSpec)
    this.SELECTEDMODELDATA(this.ProjectorSpec[0])
  },
  mounted () {
    let func = this.InitConfig.initFunction
    if (func.length) {
      this.isSearch = func.indexOf('Search') !== -1
      this.isCategolies = func.indexOf('Categolies') !== -1
      this.isSpecification = func.indexOf('Specification') !== -1
      this.isInstallCondition = func.indexOf('InstallCondition') !== -1

      if (!this.isSearch && !this.isCategolies && !this.isSpecification && !this.isInstallCondition) {
        this.isSearch = true
      }
    }
  }
}
</script>

<style scoped>
  #app .van-nav-bar {
    background: transparent;
  }

  #app .van-nav-bar__title{
    font-weight: bold
  }

  .home-bg {
    height: 100vh;
    padding-bottom: 10px;
  }
</style>
